import * as schemas from './schemas'
import * as Joi from 'joi'
import { ja } from './language'

const v = Joi.defaults(schema => {
  return schema.prefs({
    messages: ja,
    abortEarly: true,
    presence: 'required',
  })
})

function validate(inputs, schema) {
  if (!schema) return Promise.resolve(inputs)

  return v.object(schema).validateAsync(inputs)
}

export { schemas, validate, v as validator }
